import _default from './Form';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Form/index.js
// module id = 935
// module chunks = 0